import { useState } from "react";
import { UserPlus, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";

export const ConvertToCustomerButton = ({ name, email, phone, testId }) => {
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);

  const convert = async () => {
    setBusy(true);
    try {
      await api.post("/admin/customers", { name, email, phone: phone || "" });
      setDone(true);
      toast.success(`${name} added as a customer — set their plan and click Invite in the Customers panel`);
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    } finally {
      setBusy(false);
    }
  };

  if (done) return <p className="text-xs font-bold text-green-700 mt-2 flex items-center gap-1"><UserPlus className="w-3.5 h-3.5" /> Added to Customers</p>;

  return (
    <button type="button" onClick={convert} disabled={busy} data-testid={testId}
      className="mt-2 border-2 border-brand text-brand hover:bg-brand hover:text-white disabled:opacity-50 font-bold px-3 py-1.5 rounded-sm text-xs flex items-center gap-1.5 transition-colors duration-200">
      {busy ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <UserPlus className="w-3.5 h-3.5" />} Convert to Customer
    </button>
  );
};
